"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgThumbDown = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", d: "M12.582 28.5a3.16 3.16 0 0 0 2.28-.982 3.35 3.35 0 0 0 .924-2.317v-1.587c0-1.779.678-3.477 1.874-4.723a6.3 6.3 0 0 1 2.636-1.65v-2.074a8.27 8.27 0 0 0-4.08 2.34c-1.56 1.626-2.43 3.824-2.43 6.107v1.587c0 .358-.137.692-.367.933a1.16 1.16 0 0 1-.837.365 1.16 1.16 0 0 1-.837-.365 1.35 1.35 0 0 1-.367-.933v-3.453c0-.555-.178-1.1-.513-1.545a2.47 2.47 0 0 0-1.381-.917l-1.409-.321a3.4 3.4 0 0 1-1.895-1.332 3.73 3.73 0 0 1-.676-2.336v-.004l.293-5.18A5.22 5.22 0 0 1 7.39 6.832c.9-.848 2.06-1.31 3.257-1.31h4.785c.449 0 .896.065 1.328.194l3.535 1.052V4.681L17.333 3.8a6.7 6.7 0 0 0-1.9-.278h-4.785a6.75 6.75 0 0 0-4.629 1.856A7.22 7.22 0 0 0 3.801 9.98l-.294 5.208v.007a5.73 5.73 0 0 0 1.042 3.596 5.4 5.4 0 0 0 3.065 2.12l1.407.32c.09.026.178.083.245.173.07.093.112.214.112.343v3.454c0 .862.328 1.696.924 2.317a3.16 3.16 0 0 0 2.28.981" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, d: "M28.5 18.202a1 1 0 0 1-1 1h-4.244a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1H27.5a1 1 0 0 1 1 1z" })));
exports.default = SvgThumbDown;
